export type PositionChangeModalProps = {
  title: string
  currentPosition: number
  maxPosition: number
  topPositionLabel?: string
  bottomPositionLabel?: string
  onSubmit: (values: FormValues) => void
  close: () => void
}

export enum FormFields {
  type = 'type',
  exactPosition = 'exactPosition',
}

export type FormValues = {
  [FormFields.type]?: 'TOP' | 'BOTTOM' | 'EXACT'
  [FormFields.exactPosition]: number
}
